import React from "react";
import { Modal, ConfigProvider } from "antd";
import useScrollLock from "../../hooks/useScrollLock";
import { useNavigate } from "react-router-dom";
import { getFormatForDateFormat } from "../../utils/Common";
import { navToOrderDetails, navToOrderEdit, navToPayment } from "../../services/order-common-service";

function ShowOrderModal({ openModal, records }) {
  const navigate = useNavigate();

  // Lock scroll when modal is open
  useScrollLock(openModal);

  const handleCancel = () => {
    records.onCancel();
  };

  const onClickOrder = (order) => {
    if (order.orderStatus === "Pending") {
      navToPayment(navigate, order.orderId, "TABLE");
      return;
    }

    if (order.orderStatus === 'Completed') {
      navToOrderDetails(navigate, order.orderId, 'TABLE');
      return;
    }
    
    navToOrderEdit(navigate, order.orderId, "TABLE", "No");
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        width={700}
        maskClosable={false}
        open={openModal}
        onOk={handleCancel}
        onCancel={handleCancel}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        styles={{
          body: { minHeight: 250 },
        }}
      >
        <div className="flex flex-col font-uregular mb-10">
          <div className="text-2xl font-ubold mb-8">Please select an order to proceed.</div>
          <div className="grid gap-y-5">
            {records.orders.map((item) => {
              return (
                <div
                  onClick={() => onClickOrder(item)}
                  key={item.orderId}
                  className="grid gap-x-2 gap-y-3 text-sm p-2 border border-gray-200 rounded cursor-pointer
                 grid-cols-[150px_120px_80px_auto_auto]"
                >
                  <div className="shadow-sm">Ordr # {item.orderNumber}</div>
                  <div className="shadow-sm">+{item.phoneNumber}</div>
                  <div className="text-blue-600 rounded shadow-sm">{item.orderStatus}</div>
                  <div className="shadow-sm">{item.totalPrice.toFixed(2)} TK</div>
                  <div className="shadow-sm">{getFormatForDateFormat(item.createdAt)}</div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default ShowOrderModal;
